export function makeId (length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length;
  for ( var i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export function debounce (fn, wait) {
  let timer
  return function (...args) {
    if (timer) clearTimeout(timer)
    const context = this
    timer = setTimeout(() => {
      fn.apply(context, args)
    }, wait)
  }
}

/**
 * Returns bytes converted to the bigger int number with or without unit
 * 
 * @param {number} x Bytes to convert
 * @param {number} base Base multiplier used for conversion (e.g. MiB 1024, MB 1000)
 * @param {boolean} add_unit Output the result with the unit string 
 * @returns {number, string} Converted bytes with or without unit
 */
export function niceBytes (x, base, add_unit = false) {
  const unit_names = {
    1000: ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    1024: ['bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
  }
  let l = 0, n = parseInt(x, 10) || 0
  while (n >= base && ++l) {
    n = n / base
  }
  const decimals = n < 10 && l > 0 ? 2 : 1 // 1 decimal for single digit (<10) results. 1 for bigger amounts (>10)
  const value = n.toFixed(decimals)
  const unit = ' ' + unit_names[base][l]
  return (add_unit) ? value + unit : value
}

export function splitFullName(fullName) {
  // Split the fullName string by the first space
  const [firstName, ...rest] = fullName.split(' ')

  // Join the remaining parts to form the surname
  const surname = rest.join(' ')

  return {
    firstName: firstName,
    surname: surname
  }
}